import HalfScreenRegion from '../assets/libs/region.js';
import halfScreenDialog from '../assets/libs/base.js';
import * as Parser from '../assets/libs/parser.js';
import * as Share from '../assets/libs/share.js';

import AppBtn from '@tencent/wxgamelib/common/appBtn';
import ShareBtn from '@tencent/wxgame-components/ShareBtn/share.vue';
import Button from '../Button/button.vue';
import { API, FLIB, Dialog, Report } from '../../apis/index.js';

import {
  ERRORS,
  SourceType as ST,
  SKButtonStatus as BS,
  RESEVE_MAP,
  GAME_MAP,
  Config,
  APP_TYPE
} from '../../apis/enums.js';

const Env = WXGAME.Env;

export default {
  name: 'gift-feedlist',
  data() {
    return {
      isloading: false,
      feedlist: [],
      region_config: {
        appid: '',
        has_role: false,
        role: {}
      },
      openid: '',
      commReport: {
        pid: 3,
        area: 21
      },
      shareData: {},
      lastGift: {},
      appBtn: null
    };
  },
  props: {
    config: {
      type: Object,
      default: {}
    }
  },
  watch: {
    config: {
      immediate: true,
      deep: true,
      handler: function(nv = {}) {
        if (nv && Object.keys(nv).length > 0) {
          this.renderConfig(nv);
        }
      }
    }
  },
  mounted() {
    this.loadList();
  },
  components: {
    'gift-button': Button,
    ShareBtn
  },
  methods: {
    renderConfig(conf = {}) {
      if (!conf.actid) {
        throw new Error('must supply a actid');
      }
      if (conf.reload) {
        this.loadList();
      }
    },
    loadList() {
      let actid = this.config.actid;
      if (this.isloading) {
        return;
      }
      this.isloading = true;
      API.loadRewardList(actid, (suc, res) => {
        this.isloading = false;
        if (suc && res && res.errcode == 0) {
          let data = res.data || {};
          this.appitems = data.appitem_map || {};
          this.openid = data.current_openid || '';
          this.prepareAppItems(this.appitems);
          this.renderRewardList(data.list || [], data.openid || data.current_openid || '');
          Report.batchReport(
            'wx62d9035fd4fd2058',
            3,
            21,
            1,
            Config.actid,
            this.lastGift.giftid || 0,
            JSON.stringify({
              openid: this.openid
            })
          );
        }
      });
    },
    renderRewardList(list, openid) {
      let appmap = this.appitems || {};
      if (list.length > 0) {
        this.feedlist = list.map((i, j) => {
          let r = i.record || {};
          let s = i.source_info || {};
          let a = i.app_info || {};
          let ga = i.game_app_info || {}; // 2023
          let appid = a.appid || r.appid || s.appid || ga.appid;
          let app = appid in appmap ? appmap[appid] : {};
          let parsed = Parser.fillParams(i, openid, app);
          let button = Parser.getButtonInfo(parsed, openid);
          if (appid in appmap) {
            parsed.app_icon = app.IconURL || '';
            if (!parsed.app_name) {
              parsed.app_name = app.BriefName || '微信游戏';
            }

            // 2023 小游戏处理逻辑
            if (ga.app_type === APP_TYPE.MINI_GAME) {
              parsed.app_icon = ga.app_icon || '';
              parsed.app_name = ga.appname || '';
              parsed.minigame_path = ga.minigame_path
                ? `weapp://${appid}?env_version=release&path=${encodeURIComponent(
                    ga.minigame_path
                  )}`
                : '';
            }
          }

          // 2023 新增
          parsed.actid = this.config.actid;

          // console.log(button.appinfo);
          return {
            button,
            index: j,
            ...parsed
          };
        });
      }
    },
    prepareAppItems(appmaps = {}) {
      let _this = this;
      let _applist = [];
      for (let appid in appmaps) {
        _applist.push(appmaps[appid]);
      }
      if (_applist.length > 0) {
        _this.appBtn = new AppBtn({
          appitemList: _applist,
          params: {
            sceneid: _this.commReport.pid,
            uiarea: _this.commReport.area
          },
          config: {
            downloadInternal: true,
            needProgress: false,
            hideReservedDialog: true
          },
          callback: {
            action: ({ appitem, dom, actionid, actionKey }) => {
              if (actionKey == 'un_reserve') {
                _this.appitem.IsSubscribed = false;
              }
              if (RESEVE_MAP[actionKey]) {
                _this.appitem.IsSubscribed = true;
                let autoDownload =
                  Env.isAndroid &&
                  (appitem.IsAllowWifiAutoDownload ||
                    appitem.is_allow_wifi_autodownload ||
                    appitem.DownloadInfo.is_allow_wifi_autodownload);
                new ReserveDialog({
                  autoDownload: autoDownload,
                  appitem: appitem,
                  type: '预约',
                  close: function(checked, hasCard) {
                    _this.is_reserved = true;
                    _this.send2Game();
                    Report.batchReport(
                      appitem.AppID,
                      3,
                      21,
                      104,
                      Config.actid,
                      _this.lastGift.giftid || 0,
                      JSON.stringify({
                        openid: _this.openid
                      })
                    );
                    // DONE1 未上线-未预约-预约成功半屏 曝光上报
                  },
                  jumpCbk: function(obj = {}) {
                    // DONE 圈子入口点击上报
                    if (obj) {
                      Report.batchReport(
                        appitem.AppID,
                        3,
                        21,
                        40,
                        Config.actid,
                        _this.lastGift.giftid || 0,
                        JSON.stringify({
                          openid: _this.openid,
                          fri: 0,
                          linktar: obj.type == 'community' ? 5 : 9
                        })
                      );
                    }
                  }
                });
                // DONE 未上线-未预约-预约成功半屏 曝光上报
              } else if (GAME_MAP[actionKey]) {
                // DONE1 上线-兑换 游戏启动相关上报
                Report.batchReport(
                  appitem.AppID,
                  3,
                  21,
                  RESEVE_MAP[actionKey],
                  Config.actid,
                  Config.actid,
                  _this.lastGift.giftid || 0,
                  JSON.stringify({
                    openid: _this.openid,
                    fri: 0
                  })
                );
              }
            }
          }
        });
      }
    },
    eventHandler(info = {}, isJump = false) {
      let _this = this;
      let button = info.button || {};
      if (isJump) {
        button.button_action = 'jump_url';
      }
      switch (button.button_action) {
        case 'jump_url':
          if (/^https?:\/\//.test(button.button_params)) {
            Report.batchReport(
              info.appid,
              3,
              21,
              40,
              Config.actid,
              info.giftid,
              JSON.stringify({
                openid: _this.openid,
                linktar: 8,
                fri: info.is_owner ? 0 : 1
              })
            );
            WXGAME.openUrl(button.button_params, { ssid: 63 });
            // FLIB.openUrl(button.button_params, { ssid: 63 });
          } else {
            console.error('invalid url', button.button_params);
          }
          break;
        default:
          if (this[button.button_action] && typeof this[button.button_action] == 'function') {
            this[button.button_action](info);
          } else {
            console.warn('invalid button action');
          }
          break;
      }
    },
    showRegion(param = {}, cbk) {
      let params = {
        appid: param.appid,
        dialog: halfScreenDialog,
        confirmText: '确认',
        receiveCallback: function(roleinfo) {
          console.log(roleinfo);
          cbk(roleinfo);
        }
      };
      new HalfScreenRegion(params);
    },
    /**
     * 领取礼包统一收拢入口
     *  @return void
     */
    getGift(params = {}) {
      let _this = this;
      let _need_partition = params.is_partition || false; // 2023
      // let _need_partition = partitionConfig[params.appid] || false;
      _this.lastGift = params;
      if (!_need_partition) {
        _this.send2Game(params);
        return;
      }
      if (_this.partition == 'check_again') {
        _this.queryPartition(params.appid, (ret) => {
          if (ret != 'check_again') {
            if (ret) {
              _this.showRegion(params, () => {
                _this.send2Game(params);
              });
            } else {
              _this.send2Game(params);
            }
          }
        });
      } else if (_need_partition) {
        _this.showRegion(params, () => {
          _this.send2Game(params);
        });
      } else {
        _this.send2Game(params);
      }
    },
    getRedpackCover(params = {}) {
      this.send2Game(params);
    },
    updateGiftBtn(params = {}) {
      this.feedlist.forEach((i, j) => {
        if (params.appid == i.appid && params.token == i.token) {
          i.status = BS.STATUS_RECEIVED;
          let extra = i.extra || {};
          let button = Parser.getButtonInfo(i, extra.openid);
          i.button = button;
          this.feedlist[j] = { ...i };
        }
      });
    },
    showShare(params) {
      let _this = this;
      params.desc = 1;
      let e = FLIB.getShareData(params, Config);
      e.link = `${params.button.button_params}`.replace(/&c=1/g, '');
      Report.batchReport(
        params.appid,
        3,
        21,
        32,
        Config.actid,
        params.giftid,
        JSON.stringify({
          openid: _this.openid,
          fri: 1
        })
      );
      function shareCbk(ret, type) {
        let action = type == 1 ? 9 : 8;
        Report.batchReport(
          params.appid,
          3,
          21,
          action,
          Config.actid,
          params.giftid,
          JSON.stringify({
            openid: _this.openid,
            list: 0
          })
        );
      }
      let shareData = Share.setShareInfo(e, shareCbk);
      _this.shareData = shareData;
      _this.$nextTick(() => {
        _this.$refs.share.setShare(shareData, shareCbk);
        _this.$refs.share.showShareTips(shareCbk, shareData.timeline);
      });
    },
    /**
     * 真正领取礼包发送礼包
     * @return void
     */
    send2Game(params = {}) {
      let _this = this;
      if (_this.sending) {
        return;
      }

      _this.sending = true;
      Report.batchReport(
        params.appid,
        3,
        21,
        2,
        Config.actid,
        params.giftid,
        JSON.stringify({
          openid: _this.openid,
          fri: 0
        })
      );
      API.sendRewardRequest(params.appid, +params.actid, params.token, (suc, res) => {
        _this.sending = false;
        if (Env.isPC) {
          suc = true;
          res = {
            errcode: suc ? 0 : -1,
            data: {}
          };
        }
        if (suc) {
          let extra = params.extra || {};
          _this.$emit('get-gift-success', {
            giftid: params.giftid || extra.giftid || 0,
            appid: params.appid,
            event: extra.event || 0,
            type: extra.type || 0,
            is_owner: params.is_owner
          });
          if (res && res.errcode == 0) {
            let msg = '领取成功';
            let btn = params.button || {};
            _this.updateGiftBtn(params);
            Report.batchReport(
              params.appid,
              3,
              21,
              109,
              Config.actid,
              params.giftid,
              JSON.stringify({
                openid: _this.openid,
                fri: 0
              })
            );
            if (
              btn._type == ST.TYPE_CASH ||
              btn._type == ST.TYPE_THING ||
              btn._type == ST.TYPE_RED_PACKET ||
              btn._type == ST.TYPE_APPOINTMENT_GIFT
            ) {
              _this.alert(msg);
              return;
            }
            _this.showResultMsg(msg, params);
          } else {
            let msg = '领取失败，请稍后再试';
            if (res && res.errcode in ERRORS) {
              msg = ERRORS[res.errcode];
            }
            _this.showTips(msg, res.errcode);
            _this.$emit('event', {
              type: 'get_gift',
              data: {
                ..._this.originConf,
                errcode: res.errcode
              },
              errcode: res.errcode,
              errmsg: JSON.stringify(res)
            });
          }
        } else {
          _this.showTips('领取失败，请稍后再试', 110);
        }
      });
    },
    /**
     *
     * @param appid
     * @param cbk
     */
    queryPartition(appid, cbk) {
      let _this = this;
      if (/^wx[a-z0-9]{16}$/i.test(appid)) {
        API.hasPartition(
          _this.appid,
          (suc, ret) => {
            if (suc) {
              partitionConfig[appid] = ret;
            }
            if (typeof cbk == 'function') {
              cbk(ret);
            }
          },
          true
        );
      }
    },
    /**
     *
     * @param msg
     * @param code
     * @param title
     * @param cbk
     * @param closecbk
     */
    showTips(msg, code = 99, cbk = false, closecbk = false) {
      let opt = {
        confirmTxt: code == 0 ? '进入游戏' : '我知道了',
        style: code == 0 ? 'twoBtn' : 'oneBtn',
        code
      };
      if (cbk && typeof cbk == 'function') {
        opt.confirmCb = cbk;
      }
      if (closecbk && typeof closecbk == 'function') {
        opt.closeCb = closecbk;
      }
      Dialog.alert(msg, opt);
    },
    alert(msg, oktext = '我知道了') {
      Dialog.alert(msg, {
        style: 'oneBtn',
        confirmTxt: oktext
      });
    },
    showResultMsg(msg, params = {}) {
      let _this = this;

      // 2023 根据奖励类型在成功之后执行不同的操作
      if (params.type === ST.TYPE_CDKEY) {
        // 外部游戏cdkey
        this.showOuterTips(params);
      } else if (params.type === ST.TYPE_WXAG) {
        // 小游戏
        this.showMiniGameTips(params);
      } else {
        _this.showTips(
          msg,
          0,
          () => {
            if (params.appid) {
              if (Env.isAndroid) {
                let url = FLIB.getUrl(
                  params.appid,
                  _this.appitems[params.appid].WebURL,
                  _this.commReport.pid
                );
                Report.batchReport(
                  params.appid,
                  3,
                  21,
                  6,
                  Config.actid,
                  params.giftid,
                  JSON.stringify({
                    openid: _this.openid,
                    fri: 0,
                    linktar: 10
                  })
                );
                WXGAME.openUrl(url, { ssid: 63 });
                // FLIB.openUrl(url, { ssid: 63 });
              } else {
                _this.appBtn.forceAction(params.appid);
              }
            } else {
              console.log(params);
            }
          },
          () => {
            _this.$emit('event', {
              type: 'close_launch_game',
              data: {
                ...params,
                opstat: 2
              }
            });
          }
        );
      }
    },
    // 2023 新增
    // 外部游戏显示兑换码
    showOuterTips(params) {
      let opt = {
        confirmTxt: '查看兑换码',
        style: 'twoBtn'
      };
      opt.confirmCb = () => {
        if (/^https?:\/\//.test(params.button.button_params)) {
          WXGAME.openUrl(params.button.button_params, { ssid: 63 });
        } else {
          console.error('invalid url', params.button.button_params);
        }
      };
      opt.closeCb = () => {
        this.$emit('event', {
          type: 'close_launch_game',
          data: {
            ...params,
            opstat: 2
          }
        });
      };
      Dialog.alert('领取成功', opt);
    },
    // 小游戏拉起小游戏
    showMiniGameTips(params) {
      let opt = {
        confirmTxt: '进入游戏',
        style: 'twoBtn'
      };
      opt.confirmCb = () => {
        WXGAME.openUrl(params.minigame_path, { ssid: 63 });
      };
      opt.closeCb = () => {
        this.$emit('event', {
          type: 'close_launch_game',
          data: {
            ...params,
            opstat: 2
          }
        });
      };
      Dialog.alert('领取成功', opt);
    }
  }
};
